export const ACTIONS = {
  ROWS_PER_PAGE: 'table-rows-per-page'
}

export default {
  setRowsPerPage: (rows) => ({ type: ACTIONS.ROWS_PER_PAGE, rowsPerPage: rows})
}
